(() => {
  'use strict';
  document.querySelectorAll('.ihn-pdp-upgrade').forEach(root => {
    const form = root.querySelector('.ihnpc__form');
    const area = root.querySelector('[data-ihnpc-area]');
    const waste = root.querySelector('[data-ihn-pdp-waste]');
    const quote = root.querySelector('[data-ihn-pdp-quote]');
    const panel = root.querySelector('.ihn-pdp-install-panel');
    const modes = root.querySelectorAll('[data-ihn-pdp-mode]');
    const updateQuote = () => {
      if (!quote) return;
      const url = new URL(quote.getAttribute('href'), window.location.origin);
      if (area && Number(area.value) > 0) url.searchParams.set('m2', area.value);
      if (waste) url.searchParams.set('snijverlies', waste.value);
      quote.href = url.pathname + url.search;
    };
    modes.forEach(button => button.addEventListener('click', () => {
      const install = button.dataset.ihnPdpMode === 'installation';
      root.dataset.ihnPdpMode = install ? 'installation' : 'material';
      modes.forEach(mode => mode.setAttribute('aria-pressed', String(mode === button)));
      if (panel) panel.hidden = !install;
      updateQuote();
    }));
    form?.addEventListener('submit', event => {
      if (root.dataset.ihnPdpMode === 'installation') {
        event.preventDefault();
        event.stopImmediatePropagation();
        quote?.focus();
      }
    });
    area?.addEventListener('input', updateQuote);
    waste?.addEventListener('change', updateQuote);
    root.querySelectorAll('.ihnpc__thumb').forEach(thumb => {
      thumb.setAttribute('aria-pressed', String(thumb.classList.contains('is-on')));
      thumb.addEventListener('click', () => {
        root.querySelectorAll('.ihnpc__thumb').forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      });
    });
    updateQuote();
  });
})();
